// ALERT

import { inject } from '@angular/core';
import { AlertService } from '../../../api/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, delay, exhaustMap } from 'rxjs';
import { mapResponse } from '@ngrx/operators';
import { alertActions } from './alert.actions';
import { LoadingState } from '../models/loader.model';
import { getErrorMessage, ZetraError } from '../../shared/errors/error-messages.helper';

//find all
export const alertLoadEffect = createEffect(
  (actions$ = inject(Actions), alertService = inject(AlertService)) => {
    return actions$.pipe(
      ofType(alertActions.loadAlertList),
      concatMap((props) =>
        alertService.alertControllerFindAllAlert(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              alertActions.loadAlertListDone({ data: r.data, state: { value: LoadingState.SUCCESS }, request: props }),
            error: (error: ZetraError) =>
              alertActions.loadAlertListDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
//loadOne
export const alertLoadOneEffect = createEffect(
  (actions$ = inject(Actions), alertService = inject(AlertService)) => {
    return actions$.pipe(
      ofType(alertActions.loadOneAlert),
      concatMap((props) =>
        alertService.alertControllerFindOneAlert(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) => alertActions.loadOneAlertDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: ZetraError) =>
              alertActions.loadOneAlertDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

//mark as resolved
export const markAsResolvedEffect = createEffect(
  (actions$ = inject(Actions), alertService = inject(AlertService)) => {
    return actions$.pipe(
      ofType(alertActions.markAsResolved),
      concatMap((props) =>
        alertService.alertControllerMarkAsResolved(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) => alertActions.markAsResolvedDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: ZetraError) =>
              alertActions.markAsResolvedDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

//mark multiple as resolved (batch mode)
export const markAlertsAsResolvedEffect = createEffect(
  (actions$ = inject(Actions), alertService = inject(AlertService)) => {
    return actions$.pipe(
      ofType(alertActions.markAlertsAsResolved),
      exhaustMap((props) =>
        alertService.alertControllerMarkAlertsAsResolved(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              alertActions.markAlertsAsResolvedDone({ state: { value: LoadingState.SUCCESS }, request: props.body }),
            error: (error: ZetraError) =>
              alertActions.markAlertsAsResolvedDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
